import { SockType } from './new-sock';

const sockConfig = {
  // 平角内裤数据
  [SockType.BOXER]: {
    // 相机坐标
    cameraPosition: [1240, 945, 440],
    // 相机看向坐标
    cameraLookat: [0, 20, 0],
    // 初始动画相机坐标
    initialCamera: { x: -38.795, y: 71.961, z: 828.413 },
    // 初始模型坐标
    initialObject: { x: 0, y: 30, z: 0 },
    // 刻字坐标
    amplify: {
      camera: { x: -19.147, y: 65.143, z: 495.096 },
    },
    // 确认刻字坐标
    confirm: {
      mesh: { x: 0, y: 0, z: 0 },
    },
  },
  [SockType.BOXER015Z]: {
    // 相机坐标
    cameraPosition: [1240, 945, 440],
    // 相机看向坐标
    cameraLookat: [0, 20, 0],
    // 初始动画相机坐标
    initialCamera: { x: -38.795, y: 71.961, z: 828.413 },
    // 初始模型坐标
    initialObject: { x: 0, y: 30, z: 0 },
    // 刻字坐标
    amplify: {
      camera: { x: -19.147, y: 65.143, z: 495.096 },
    },
    // 确认刻字坐标
    confirm: {
      mesh: { x: 0, y: 0, z: 0 },
    },
  },
  [SockType.BOXER435]: {
    // 相机坐标
    cameraPosition: [1240, 945, 440],
    // 相机看向坐标
    cameraLookat: [0, 20, 0],
    // 初始动画相机坐标
    initialCamera: { x: -38.795, y: 71.961, z: 828.413 },
    // 初始模型坐标
    initialObject: { x: 0, y: 30, z: 0 },
    // 刻字坐标
    amplify: {
      camera: { x: -19.147, y: 65.143, z: 495.096 },
    },
    // 确认刻字坐标
    confirm: {
      mesh: { x: 0, y: 0, z: 0 },
    },
  },
  [SockType.BOXER395Z]: {
    // 相机坐标
    cameraPosition: [1240, 945, 440],
    // 相机看向坐标
    cameraLookat: [0, 20, 0],
    // 初始动画相机坐标
    initialCamera: { x: -38.795, y: 71.961, z: 828.413 },
    // 初始模型坐标
    initialObject: { x: 0, y: 30, z: 0 },
    // 刻字坐标
    amplify: {
      camera: { x: -19.147, y: 65.143, z: 495.096 },
    },
    // 确认刻字坐标
    confirm: {
      mesh: { x: 0, y: 0, z: 0 },
    },
  },
  // KY平角内裤数据
  [SockType.KYBOXER]: {
    // 相机坐标
    cameraPosition: [1240, 945, 440],
    // 相机看向坐标
    cameraLookat: [0, 20, 0],
    // 初始动画相机坐标
    initialCamera: { x: -31.018, y: 235.065, z: 802.035 },
    // 刻字坐标
    amplify: {
      camera: { x: -18.571, y: 148.767, z: 480.207 },
    },
  },
  // 袜子数据
  [SockType.SOCK]: {
    // 相机坐标
    cameraPosition: [300, 240, 120],
    // 相机看向坐标
    cameraLookat: [8.457, 16.749, 6.074],
    // 初始动画相机坐标
    initialCamera: { x: -0.804, y: 47.708, z: 121.320 },
    // 刻字坐标
    amplify: {
      camera: { x: -19.342, y: 19.455, z: 55.306 },
      cameraUp: { x: -0.22, y: 1, z: 0 },
      control: { x: -3.348, y: 19.811, z: 2.921 },
    },
  }
}

export default sockConfig;
